import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';

import {
  LOAD_COMMUNICATIONS,
  LOAD_COMMUNICATION,
  UPDATE_COMMUNICATION,
  HARD_DELETE_COMMUNICATION,
  COPY_COMMUNICATION,
  // answers
  LOAD_COMMUNICATION_ANSWERS,
  UPDATE_COMMUNICATION_ANSWERS,
} from './constants';

import {
  loadCommunicationsSuccess,
  loadCommunicationsError,
  loadCommunicationSuccess,
  loadCommunicationError,
  changeCommunicationSuccess,
  changeCommunicationError,
  hardDeleteCommunicationSuccess,
  hardDeleteCommunicationError,
  copyCommunicationSuccess,
  copyCommunicationError,
  // answers
  loadCommunicationAnswersSuccess,
  loadCommunicationAnswersError,
  changeCommunicationAnswersSuccess,
  changeCommunicationAnswersError,
} from './actions';

import { getObjId } from 'utils/helpers/helper.general';
import history, { parseQuery, encodeQueryData } from 'utils/history';

// utils
import api, { endpoint } from 'utils/apis/axiosAPI';

export function* loadListSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { params, pages } = action;
    let itemsList = false;
    let convertParams = { ...params };

    if (typeof params?.filterValue === 'string') {
      convertParams.filterValue = params?.filterValue.split(',');
    }

    // we get the campaigns linked to the communications
    if (params) {
      itemsList = yield requestWrapper(
        'POST',
        `communications/list`,
        convertParams || params,
        currentUser.token,
      );
    } else {
      itemsList = yield requestWrapper(
        'GET',
        `communications/list`,
        '',
        currentUser.token,
      );
    }

    if (!itemsList) {
      yield put(loadCommunicationsSuccess(false));
    } else {
      yield put(loadCommunicationsSuccess(itemsList, itemsList?.data, params));
    }
  } catch (error) {
    yield put(loadCommunicationsError(error));
  }
}

export function* loadCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { detailID } = action;

    // we get the campaigns linked to the communication
    const itemData = yield requestWrapper(
      'GET',
      `communications/${detailID}`,
      '',
      currentUser.token,
    );

    if (!detailID && !itemData) {
      yield put(loadCommunicationSuccess(false));
    } else {
      yield put(loadCommunicationSuccess(itemData));
    }
  } catch (error) {
    yield put(loadCommunicationError(error));
  }
}

export function* changeSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const searchParams = parseQuery(window.location.search) || null;

    const { itemDetail } = action;

    let updateElement = false,
      isNew = !itemDetail.hasOwnProperty('_id');

    if (isNew) {
      updateElement = yield requestWrapper(
        'POST',
        'communications/new/',
        itemDetail,
        currentUser.token,
      );
    } else {
      updateElement = yield requestWrapper(
        'PATCH',
        'communications/',
        itemDetail,
        currentUser.token,
      );
    }
    if (!updateElement) {
      yield put(changeCommunicationSuccess(false));
    } else if (
      updateElement.hasOwnProperty('data') ||
      updateElement.hasOwnProperty('code')
    ) {
      yield put(changeCommunicationSuccess(updateElement));
      if (updateElement?.data) {
        const serachStr = encodeQueryData(searchParams);
        history.push({
          pathname: `/communications/${updateElement?.data?._id}`,
          search: `?${serachStr}`,
          state: {
            isNew: false,
            preview: false,
          },
        });
      }
    } else {
      // if new we update the url, item props will be updated
      if (isNew && updateElement?._id) {
        const serachStr = encodeQueryData(searchParams);
        history.push({
          pathname: `/communications/` + updateElement._id,
          search: `?${serachStr}`,
          state: {
            isNew: true,
            preview: false,
          },
        });
      }
      yield put(changeCommunicationSuccess(updateElement));
    }
  } catch (error) {
    yield put(changeCommunicationError(error));
  }
}

export function* hardDeleteSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { hardDeleteId } = action;

    let hardDelte = false;
    if (!!hardDeleteId) {
      hardDelte = yield requestWrapper(
        'PATCH',
        `communications/delete`,
        { objects: [hardDeleteId] },
        currentUser.token,
      );
    }

    if (!hardDelte) {
      yield put(hardDeleteCommunicationSuccess(false));
    } else {
      yield put(hardDeleteCommunicationSuccess(hardDelte, hardDeleteId));
    }
  } catch (err) {
    yield put(hardDeleteCommunicationError(err));
  }
}

export function* copyCommunication(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const searchParams = parseQuery(window.location.search) || null;
    const { toCopyID } = action;

    let itemDetail = false;
    // we get the campaigns linked to the
    if (!!toCopyID) {
      itemDetail = yield requestWrapper(
        'POST',
        `communications/copy/${toCopyID}`,
        {},
        currentUser.token,
      );
    }

    if (!toCopyID && !itemDetail) {
      yield put(copyCommunicationSuccess(false));
    } else {
      if (itemDetail?._id) {
        let currentData = searchParams;
        const serachStr = encodeQueryData(currentData);
        history.push({
          pathname: `/communications/` + itemDetail?._id,
          search: `?${serachStr}`,
          state: {
            isNew: true,
            preview: false,
          },
        });
      }
      yield put(copyCommunicationSuccess(itemDetail));
    }
  } catch (error) {
    yield put(copyCommunicationError(error));
  }
}

/* Answers */
export function* loadCommunicationAnswersSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { detailID } = action;

    // we get the campaigns linked to the communication
    const answersObject = yield requestWrapper(
      'GET',
      `communications/answers/${detailID}/role/parent`,
      '',
      currentUser.token,
    );

    if (!detailID && !answersObject) {
      yield put(loadCommunicationAnswersSuccess(false));
    } else {
      yield put(loadCommunicationAnswersSuccess(answersObject));
    }
  } catch (error) {
    yield put(loadCommunicationAnswersError(error));
  }
}

export function* updateCommunicationAnswersSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { commID, actionType, planArray, answerType } = action;

    let planArrayRusult = null;
    
    if (!!commID && commID != ('new' || 'nouvel')) {
      // we get the campaigns linked to the communication
      planArrayRusult = yield requestWrapper(
        'PATCH',
        `communications/answers/${commID}`,
        { action: actionType, plan: planArray, type: answerType },
        currentUser.token,
      );
    }

    if (!commID && !planArrayRusult) {
      yield put(changeCommunicationAnswersSuccess(false));
    } else {
      yield put(changeCommunicationAnswersSuccess(planArrayRusult));
    }
  } catch (error) {
    yield put(changeCommunicationAnswersError(error));
  }
}


export default function* communicationsSaga() {
  yield takeLatest(LOAD_COMMUNICATIONS, loadListSaga);
  yield takeLatest(LOAD_COMMUNICATION, loadCommunicationSaga);

  yield takeLatest(UPDATE_COMMUNICATION, changeSaga);
  yield takeLatest(HARD_DELETE_COMMUNICATION, hardDeleteSaga);
  yield takeLatest(COPY_COMMUNICATION, copyCommunication);
  // answers
  yield takeLatest(LOAD_COMMUNICATION_ANSWERS, loadCommunicationAnswersSaga);
  yield takeLatest(
    UPDATE_COMMUNICATION_ANSWERS,
    updateCommunicationAnswersSaga,
  );
}
